<template>
    <div>
        <div class="d-flex justify-content-center">
            <b-card class="text-center m-1">
                <div class="m-3">
                    <p>
                        <feather-icon
                            icon="XCircleIcon"
                            size="80"
                            class="text-danger"
                        />
                    </p>
                    <h2>Oh No, Payment Failed.</h2>
                    <p>Please go back and try again.</p>
                </div>
                <b-link :to="{ name: 'home' }"
                    ><b-button variant="primary" class="mb-1"
                        >Go to Home</b-button
                    ></b-link
                >
            </b-card>
        </div>
    </div>
</template>

<script>
import { BCard, BButton, BLink } from "bootstrap-vue";
export default {
    components: {
        BCard,
        BButton,
        BLink,
    },
};
</script>

<style></style>
